import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFunnel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Weight=Regular",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.6109 2.70869C12.5436 2.55311 12.432 2.42075 12.29 2.32809C12.1481 2.23543 11.982 2.18654 11.8125 2.18751H2.18749C2.01814 2.18785 1.85252 2.23732 1.71073 2.32992C1.56895 2.42253 1.45708 2.55429 1.3887 2.70922C1.32033 2.86416 1.29838 3.0356 1.32552 3.20276C1.35267 3.36992 1.42774 3.52562 1.54163 3.65095L1.546 3.65587L5.24999 7.61087V11.8125C5.24995 11.9709 5.29289 12.1263 5.37423 12.2622C5.45557 12.398 5.57227 12.5093 5.71187 12.5841C5.85147 12.6588 6.00875 12.6943 6.16693 12.6867C6.32511 12.6791 6.47826 12.6287 6.61006 12.541L8.36006 11.3739C8.48003 11.294 8.57839 11.1857 8.64642 11.0586C8.71444 10.9315 8.75002 10.7896 8.74999 10.6455V7.61087L12.4545 3.65587L12.4589 3.65095C12.574 3.52619 12.6498 3.37029 12.6768 3.20272C12.7039 3.03514 12.6809 2.86332 12.6109 2.70869ZM8.11233 7.01533C7.96034 7.17643 7.87547 7.3894 7.87499 7.61087V10.6455L6.12499 11.8125V7.61087C6.12549 7.3886 6.04097 7.17455 5.88874 7.01259L2.18749 3.06251H11.8125L8.11233 7.01533Z",
			fill: "currentColor"
		})
	})
});
export default SvgFunnel;
